import React, { useState } from 'react';

interface DiscountModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DiscountModal: React.FC<DiscountModalProps> = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    setIsSubmitted(true);
    setIsSubmitting(false);
    
    setTimeout(() => {
      onClose();
      setIsSubmitted(false);
      setEmail('');
    }, 2000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-lg max-w-sm w-full mx-4 p-6">
        {!isSubmitted ? (
          <>
            <h2 className="text-xl font-bold text-center mb-2">Get 17% off your first purchase</h2>
            
            <p className="text-gray-600 text-center mb-4 text-sm">
              Enjoy an immediate discount right after signing up for our occasional newsletter. We never spam.
            </p>

            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-[#2b603e]"
              />

              <button
                type="submit"
                disabled={isSubmitting || !email}
                className={`w-full py-2 px-4 rounded font-medium ${
                  isSubmitting || !email
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-[#2b603e] hover:bg-[#1a3d2a] text-white'
                }`}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
              </button>

              <button
                type="button"
                onClick={onClose}
                className="w-full py-2 px-4 rounded font-medium bg-gray-200 hover:bg-gray-300 text-gray-700"
              >
                Close
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Thank You!</h3>
            <p className="text-gray-600 text-sm mb-4">
              Check your email for your 17% discount code!
            </p>
            <button
              onClick={onClose}
              className="w-full py-2 px-4 rounded font-medium bg-gray-200 hover:bg-gray-300 text-gray-700"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscountModal;
